import { useReducer, createContext } from "react";
import Notification from "./Notification";
import { INotificationProps } from "./Notification.interface";
import { ADD_NOTIFICATION, REMOVE_NOTIFICATION, RESET } from "../shared/constant";
import { Styles } from "./Notification.styles";

export const NotificationContext = createContext<any>(null);

const NotificationProvider = (props: { children: React.ReactNode }) => {
  const initialState: INotificationProps[] = [];

  const reducer = (state: INotificationProps[], action: any) => {
    switch (action.type) {
      case ADD_NOTIFICATION:
        if (state) {
          return [...state, { ...action.payload }];
        }
        return [];
      case REMOVE_NOTIFICATION:
        return state?.filter((el) => el.id !== action.id);
      case RESET:
        return [];
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <NotificationContext value={dispatch}>
      <div style={Styles.notificationContainer}>
        {state?.map((note: INotificationProps) => {
          return (
            <Notification
              key={note?.id}
              dispatch={dispatch}
              id={note?.id}
              type={note?.type}
              title={note?.title}
              timeout={note?.timeout}
              message={note?.message}
              link={note?.link}
              linkText={note?.linkText}
            />
          );
        })}
      </div>
      {props.children}
    </NotificationContext>
  );
};

export default NotificationProvider;
